<!-- 协诊管理 -->
<template>
    <div class="app-container">
        <el-container class="container" direction="vertical">
            <div class="tabs_custom">
                <el-tabs type="border-card" @tab-click="clickTab">
                    <el-tab-pane label="糖尿病协诊">
                        <component :is="currentView1" :pInfo="pInfo" v-if="update1"></component>
                    </el-tab-pane>
                    <el-tab-pane label="高血压协诊">
                        <component :is="currentView2" :pInfo="pInfo" v-if="update2"></component>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-container>
    </div>
</template>

<script>
import bloodGlucoseRecord from "./bloodGlucoseCollaborative.vue";
import bloodPressureRecord from "./bloodPressureCollaborative.vue";

export default {
    components: { bloodGlucoseRecord, bloodPressureRecord },
    props: {
        pInfo: null
    },
    data() {
        return {
            currentView1: "bloodGlucoseRecord",
            currentView2: "bloodPressureRecord",
            update1: true,
            update2: false,
        };
    },
    methods: {
        clickTab(targetName) {
            console.log(targetName);
            if (targetName.label == "糖尿病协诊") {
                this.update1 = true;
                this.update2 = false;
            } else if (targetName.label == "高血压协诊") {
                this.update1 = false;
                this.update2 = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.tabs_custom {
    ::v-deep {
        .el-tabs__content {
            overflow: auto !important;
        }
    }
}
</style>